import { atom } from 'recoil';

export const authState = atom({
    key: 'authState',
    default: {
        isLoggedIn: false,
        userDetails: {}
    }, // default value (initial value)
});